let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gMOTx")).then(() => parcelRequire('hPPLM'));